module.exports = __webpack_public_path__ + "static/media/icalendar-arrow-left.a6b87068.svg";